import React, { useEffect } from "react";
import { GridStack } from "gridstack";



import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import DMSHeader from "../DMSHeader/DMSHeader";
import CreateIncidentFormPage from "./CreateIncidentFormPage";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import CreateEventFormPage from "./CreateEventFormpage";
//import CreateResourceRegForm from "./CreateResourceRegForm";

const CreateEvent = () => {
  const { t, i18n } = useTranslation();
  const { state } = useLocation();
  let edit = state?.edit;

  useEffect(() => {
    GridStack.init();
  }, []);
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: (
        <DMSHeader title={edit ? "Update Event" : t("Create Event")} showIconsForback={true} />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 11,
      id: 1,
      component: <CreateEventFormPage />,
    },
  ];
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default CreateEvent;
